export const parseMulti = (raw?: string): string[] => {
  if (!raw || raw === 'none') return [];
  return raw.split(',').map(v => v.trim()).filter(Boolean);
};

export const toggleMulti = (raw: string | undefined, value: string): string => {
  const current = parseMulti(raw);
  const next = current.includes(value)
    ? current.filter(v => v !== value)
    : [...current, value];
  return next.length === 0 ? 'none' : next.join(',');
};

export const isMultiChecked = (raw: string | undefined, value: string): boolean =>
  parseMulti(raw).includes(value);
